import React from 'react'
import { connect } from 'react-redux'
import { Avatar, withStyles } from '@material-ui/core'
import { openProfileDialog } from 'actions/view'
import { bindActionCreators } from 'redux'

const styles = theme => ({})

const HeaderAvatar = ({
  openProfileDialog,
  given_name,
  family_name,
  account_id,
  classes,
  open,
}) => {
  return (
    <Avatar
      style={{
        backgroundColor: '#014c94',
        color: '#fff',
        width: open ? 24 : undefined,
        height: open ? 24 : undefined,
        marginBottom: open ? 4 : undefined,
        fontSize: open ? '1rem' : undefined,
        // cursor: 'pointer',
        // marginRight: 8,
      }}
      // onClick={() => openProfileDialog(true)}
    >
      {given_name.slice(0, 1)}
      {family_name.slice(0, 1)}
    </Avatar>
  )
}

export default withStyles(styles)(
  connect(
    state => ({
      given_name: state.auth?.session?.idToken?.payload?.given_name || '',
      family_name: state.auth?.session?.idToken?.payload?.family_name || '',
      account_id: state.data?.['account/preference']?.account_id,
    }),
    dispatch => bindActionCreators({ openProfileDialog }, dispatch),
  )(HeaderAvatar),
)
